import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { AccountRoleEnum } from '../onboarding-data.data';

export const ACCOUNT_MIGRATION_SCHEMA = Object.freeze({
  ACCOUNT_VERSION: 2,
  IS_ACCOUNT_MIGRATED: false,
  ROLE: '',
  CUSTOM_TEMPLATE_ENABLED: false,
  TEMPLATE_VERSION: 0,
});

const RECORD = generateSchema(ACCOUNT_MIGRATION_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_MIGRATION_SCHEMA);

export class AccountMigration extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accountVersion(): number {
    return this.get(KEYS.ACCOUNT_VERSION);
  }

  get isAccountMigrated(): boolean {
    return this.get(KEYS.IS_ACCOUNT_MIGRATED);
  }

  get role(): AccountRoleEnum {
    return this.get(KEYS.ROLE);
  }

  get isCustomTemplateEnabled(): boolean {
    return this.get(KEYS.CUSTOM_TEMPLATE_ENABLED);
  }

  isFullAccess(): boolean {
    return this.role === AccountRoleEnum.full_access;
  }
}
